export * from '@fhs/routing/src/routes/menu/(menu)/[slug]/_layout';
export { default } from '@fhs/routing/src/routes/menu/(menu)/[slug]/_layout';
